<div class="advertisement-container">
    <div class="advertisement-content container">
        @if (advertisementData.length) {
        <div class="advertisement">
            @for (item of advertisementData; track $index) {
            <div class="advertisement-item">
                <div class="left-section">
                    <p class="advertisement-subtitle-2">{{ item.subtitle2 }}</p>
                    <p class="advertisement-title">{{ item.title }}</p>
                    <p class="advertisement-subtitle-1">{{ item.subtitle1 }}</p>
                </div>
                <div class="right-section">
                    <mat-icon [svgIcon]="item.icon" class="svg-icon"></mat-icon>
                </div>
            </div>
            }
        </div>
        }
    </div>
</div>
